export const getNumOfDaysBetween = (startDate, endDate = new Date()) => {
  // hours * minutes * seconds * milliseconds
  const MS_PER_DAY = 24 * 60 * 60 * 1000; // Discard the time and time-zone information such as day light savings.

  const startDateUTC = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endDateUTC = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
  return Math.floor((endDateUTC - startDateUTC) / MS_PER_DAY);
};